<template>
  <div class="contianer">
    <page-header></page-header>
    <search :cur-type="params.type" :cur-key="params.key" @searchKey="doSearch"></search>
    <div class="result-box">
      <!-- 错误信息 -->
      <el-empty class="empty-box" v-if="errTips" :description="errTips"></el-empty>
      <div v-else-if="!loading">
        <!-- 商品信息查询 -->
        <div v-if="params.type == 'goods_id'">
          <div class="section base-info-section">
            <div class="section-container">
              <div class="comp-title-wrapper">
                <p class="comp-title">商品信息</p>
              </div>
              <div class="comp info-item-list">
                <div class="info-item">
                  <p class="item-label">商品ID：</p>
                  <p class="con" :title="assetInfo.key">
                    {{ assetInfo.assetId }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">发行时间：</p>
                  <p class="con">{{ assetInfo.publishTime }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">创作者：</p>
                  <p class="con">{{ assetInfo.merchantName }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">流通量：</p>
                  <p class="con">{{ assetInfo.flow }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">商品名称：</p>
                  <p class="con" :title="assetInfo.goods_name">
                    {{ assetInfo.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="section trade-info-section">
            <div class="section-container">
              <div class="comp-title-wrapper">
                <p class="comp-title">交易信息</p>
              </div>
              <div class="comp" v-if="list.records">
                <div class="trade-item" v-for="item in list.records" :key="item.hash">
                  <div class="info-item">
                    <p class="item-label">交易哈希：</p>
                    <a
                      class="link-a"
                      href="javascript:void(0)"
                      @click="reloadPage('trade_hash', item.hash)"
                      >{{ item.hash }}</a
                    >
                  </div>
                  <div class="info-item">
                    <p class="item-label">交易时间：</p>
                    <p class="con" :title="item.txnTime">{{ item.txnTime }}</p>
                  </div>
                  <div class="info-item">
                    <p class="item-label">商品ID：</p>
                    <p class="con" :title="assetInfo.assetId">
                      {{ assetInfo.assetId }}
                    </p>
                  </div>
                  <div class="info-item">
                    <p class="item-label">子ID：</p>
                    <p class="con" :title="item.shardId">{{ item.shardId }}</p>
                  </div>
                  <div class="info-item">
                    <p class="item-label">发送方：</p>
                    <a
                      class="link-a"
                      href="javascript:void(0)"
                      :title="item.address"
                      @click="reloadPage('addr', item.address)"
                      >{{ item.address }}</a
                    >
                  </div>
                  <div class="info-item">
                    <p class="item-label">接收方：</p>
                    <a
                      class="link-a"
                      href="javascript:void(0)"
                      :title="item.toAddress"
                      @click="reloadPage('addr', item.toAddress)"
                      >{{ item.toAddress }}</a
                    >
                  </div>
                </div>
                <div v-if="list.total >= params.page_size" class="pagination-container">
                  <el-pagination
                    background
                    :hide-on-single-page="true"
                    layout="prev, pager, next, jumper"
                    :page-size="params.page_size"
                    :total="list.total"
                    :current-page="params.page"
                    @current-change="getReuslt"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 交易哈希查询结果 -->
        <div v-if="params.type == 'trade_hash'">
          <div class="section base-info-section">
            <div class="section-container">
              <div class="comp-title-wrapper">
                <p class="comp-title">交易信息</p>
              </div>
              <div class="comp info-item-list">
                <div class="info-item">
                  <p class="item-label">交易哈希：</p>
                  <p class="con" :title="assetInfo.hash">{{ assetInfo.hash }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">发起时间：</p>
                  <p class="con">{{ assetInfo.createTime }}</p>
                </div>
                <div class="info-item" v-if="assetInfo.blockTime">
                  <p class="item-label">出块时间：</p>
                  <p class="con">{{ assetInfo.blockTime }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">商品ID：</p>
                  <a
                    class="link-a"
                    href="javascript:void(0)"
                    @click="reloadPage('goods_id', assetInfo.assetId)"
                    >{{ assetInfo.assetId }}</a
                  >
                </div>
                <div class="info-item">
                  <p class="item-label">子ID：</p>
                  <p class="con" :title="assetInfo.shard_id">
                    {{ assetInfo.shardId }}
                  </p>
                </div>
                <div class="info-item" v-if="assetInfo.blockHeight">
                  <p class="item-label">区块高度：</p>
                  <p class="con">{{ assetInfo.blockHeight }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">交易状态：</p>
                  <p class="con">
                    <el-tag v-if="assetInfo.txnStatus == 0" type="danger" size="small"
                      >失败</el-tag
                    >
                    <el-tag v-else type="success" size="small">成功</el-tag>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="section base-info-section">
            <div class="section-container">
              <div class="comp-title-wrapper">
                <p class="comp-title">记账交易</p>
              </div>
              <div class="comp transation-comp">
                <div class="info-item">
                  <a
                    v-if="assetInfo.address"
                    class="link-a"
                    href="javascript:void(0)"
                    :title="assetInfo.address"
                    @click="reloadPage('addr', assetInfo.address)"
                    >{{ assetInfo.address }}</a
                  >
                  <p v-else class="con">--</p>
                </div>
                <span class="right-arrow"></span>
                <div class="info-item">
                  <a
                    class="link-a"
                    href="javascript:void(0)"
                    :title="assetInfo.toAddress"
                    @click="reloadPage('addr', assetInfo.toAddress)"
                    >{{ assetInfo.toAddress }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NTT交易查询结果 -->
        <div v-if="params.type == 'ntt'">
          <div class="section base-info-section">
            <div class="section-title">交易信息</div>
            <div class="section-container">
              <div class="info-item">
                <p class="item-label">交易哈希：</p>
                <p class="con" :title="assetInfo.txId">{{ assetInfo.txId }}</p>
              </div>
              <div class="info-item">
                <p class="item-label">发起时间：</p>
                <p class="con">{{ assetInfo.createTime }}</p>
              </div>
              <div class="info-item" v-if="assetInfo.blockTime">
                <p class="item-label">出块时间：</p>
                <p class="con">{{ assetInfo.blockTime }}</p>
              </div>
              <div class="info-item" v-if="assetInfo.blockHeight">
                <p class="item-label">区块高度：</p>
                <p class="con">{{ assetInfo.blockHeight }}</p>
              </div>
              <div class="info-item" v-if="assetInfo.gasUsed">
                <p class="item-label">Gas费：</p>
                <p class="con">{{ assetInfo.gasUsed }}</p>
              </div>
              <div class="info-item">
                <p class="item-label">交易状态：</p>
                <p class="con">
                  <el-tag v-if="assetInfo.txnStatus == 1" type="default" size="small"
                    >未上链</el-tag
                  >
                  <el-tag v-if="assetInfo.txnStatus == 2" type="success" size="small"
                    >已上链</el-tag
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="section base-info-section">
            <div class="section-title">记账交易</div>
            <div class="section-container">
              <div class="info-item">
                <p class="item-label">发起方：</p>
                <a
                  v-if="assetInfo.address"
                  class="link-a"
                  href="javascript:void(0)"
                  :title="assetInfo.address"
                  @click="reloadPage('addr', assetInfo.address)"
                  >{{ assetInfo.address }}</a
                >
                <p v-else class="con">--</p>
              </div>
              <div class="info-item">
                <p class="item-label">接收方：</p>
                <a
                  class="link-a"
                  href="javascript:void(0)"
                  :title="assetInfo.toAddress"
                  @click="reloadPage('addr', assetInfo.toAddress)"
                  >{{ assetInfo.toAddress }}</a
                >
              </div>
              <div class="info-item">
                <p class="item-label">交易数量：</p>
                <p class="con">{{ assetInfo.amount }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 地址查询结果 -->
        <div v-if="params.type == 'addr' || params.type == 'xid'">
          <div class="section base-info-section">
            <div class="section-container">
              <div class="comp-title-wrapper">
                <p class="comp-title">用户信息</p>
              </div>
              <div class="comp blockchain-address">
                <p class="item-label">区块链地址：</p>
                <p class="con" :title="assetInfo.key">{{ assetInfo.addr }}</p>
              </div>
            </div>
          </div>
          <div class="section trade-info-section">
            <div class="section-container">
              <div class="comp-title-wrapper">
                <p class="comp-title">持有商品信息</p>
              </div>
              <div class="record-table-wrapper comp" v-if="list.records">
                <table class="record-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>商品ID</th>
                    <th>创作者</th>
                    <th>子ID</th>
                    <th>状态</th>
                  </tr>
                  <tr v-for="(item, index) in list.records" :key="index">
                    <td>
                      <a
                        class="link-a"
                        href="javascript:void(0)"
                        @click="reloadPage('goods_id', item.assetId)"
                        >{{ item.assetId }}</a
                      >
                    </td>
                    <td>{{ item.merchantName }}</td>
                    <td>{{ item.shardId }}</td>
                    <td>
                      <el-tag v-if="item.status == 1" type="success" size="small"
                        >正常</el-tag
                      >
                      <el-tag v-else type="danger" size="small">销毁</el-tag>
                    </td>
                  </tr>
                </table>
                <div v-if="list.total >= params.page_size" class="pagination-container">
                  <el-pagination
                    background
                    :hide-on-single-page="true"
                    layout="prev, pager, next, jumper"
                    :page-size="params.page_size"
                    :total="list.total"
                    :current-page="params.page"
                    @current-change="getReuslt"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageHeader from "@/components/page-header";
import pageFooter from "@/components/page-footer";
import search from "@/components/search";
import { formatNum } from "@/utils/comm.js";
export default {
  name: "home",
  components: {
    pageHeader,
    pageFooter,
    search,
  },
  data() {
    return {
      params: {
        type: "",
        page: 1,
        key: "",
        page_size: 10,
      },
      assetInfo: {},
      list: {},
      errTips: "",
      loading: false,
    };
  },
  mounted() {
    let { type, key } = this.$route.query;
    this.searchKey(type, key);
  },
  methods: {
    reloadPage(type, key) {
      if (type == this.params.type && key == this.params.key) {
        this.searchKey(type, key);
        return;
      }

      this.$router.push(`search?type=${type}&key=${key}`);
    },
    doSearch(obj) {
      this.searchKey(obj.type, obj.key);
    },
    searchKey(type, key) {
      if (!key || !type) {
        return;
      }
      this.params.key = key;
      this.params.type = type;
      this.getReuslt();
    },
    getReuslt(page) {
      this.errTips = "";
      this.params.page = page || 1;

      if (!this.params.key) {
        this.assetInfo = {};
        this.list = {};
        return;
      }
      this.$loading();
      this.loading = true;

      let searchType = this.params.type;

      if (searchType == "goods_id") {
        //  商品查询
        this.queryAssetInfo(page);
      } else if (searchType == "trade_hash") {
        //  哈希查询
        this.queryTransaction();
      } else if (searchType == "addr" || searchType == "xid") {
        //  账号地址查询
        this.queryAddress(page);
      } else if (searchType == "ntt") {
        //  NTT交易查询
        this.queryNttTrade();
      }
    },
    queryNttTrade() {
      this.$api
        .queryNttTrade({
          tx_id: this.params.key,
        })
        .then((res) => {
          this.$loading().close();
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            let data = res.data || {};
            data.blockHeight =
              data.blockHeight != null ? formatNum(data.blockHeight) : "--";
            this.assetInfo = data;
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
    queryAddress() {
      this.$api
        .queryAddress({
          addr: this.params.key,
          page: this.params.page,
        })
        .then((res) => {
          this.$loading().close();
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            this.list = res.data || {};
            this.assetInfo = {
              addr: this.params.key,
              ntt_balance: this.list.ntt_balance,
            };
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
    queryTransaction() {
      let hash = this.params.key;
      this.$api
        .queryTransaction({
          tx_id: hash,
        })
        .then((res) => {
          res = res.data;
          this.$loading().close();
          this.loading = false;
          if (res.code == 1) {
            let assetInfo = res.data;
            assetInfo.hash = hash;
            assetInfo.blockHeight =
              assetInfo.blockHeight != null ? formatNum(assetInfo.blockHeight) : "--";
            this.assetInfo = assetInfo;
            this.list = {};
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
    queryAssetInfo() {
      this.$api
        .queryAssetInfo({
          asset_id: this.params.key,
          page: this.params.page,
        })
        .then((res) => {
          res = res.data;
          this.$loading().close();
          this.loading = false;
          if (res.code == 1) {
            let data = res.data;
            let assetInfo = data.asset_info;
            assetInfo.assetId = this.params.key;
            assetInfo.total_num = formatNum(assetInfo.total_num);
            this.assetInfo = assetInfo;
            this.list = data.tx_info;
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
  },
};
</script>
<style scoped>
.result-box {
  min-height: 400px;
  position: relative;
}

.result-box:after {
  content: "";
  width: 1500px;
  background-image: url("../../assets/decoration2.png");
  background-repeat: repeat;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.section:nth-child(1) {
  margin-top: -20px;
}

.section.base-info-section .info-item-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 80px 40px;
}

.section.base-info-section .info-item-list .info-item + .info-item {
  margin-top: 20px;
}

.section .info-item {
  display: flex;
  align-items: center;
  width: 45%;
  height: 40px;
  font-size: 20px;
}

.section .info-item .item-label {
  color: #fff;
  width: 100px;
  flex-shrink: 0;
  flex-grow: 0;
}

.section .info-item .con,
.section .info-item .link-a {
  color: #fff;
  font-family: DIN;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section.trade-info-section .trade-item {
  padding: 20px 80px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.section.trade-info-section .trade-item + .trade-item {
  border-top: 1px solid rgba(255, 255, 255, 0.4);
}

.section.trade-info-section .trade-item .info-item {
  margin-top: 20px;
}

.empty-box {
  padding: 200px 300px;
}

.pagination-container {
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #ffffff;
  color: #1677ff;
  border: 1px solid;
  border-radius: 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/deep/ .el-pagination.is-background .el-pager li,
/deep/ .el-pagination.is-background .btn-next,
/deep/ .el-pagination.is-background .btn-prev {
  background: transparent;
  color: #ffffffe0;
  font-weight: normal;
}

/deep/ .el-tag {
  background: transparent;
  font-family: DIN;
  font-size: 20px;
  font-weight: 700;
  position: relative;
  padding-right: 60px;
}

/deep/ .el-tag:after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}

/deep/ .el-tag.el-tag--success {
  color: #11d25f;
}

/deep/ .el-tag.el-tag--danger {
  color: #f00;
}

/deep/ .el-tag.el-tag--success:after {
  background: #11d25f;
}

/deep/ .el-tag.el-tag--danger:after {
  background: #f00;
}

.transation-comp {
  height: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transation-comp .right-arrow {
  display: block;
  margin: 0 30px;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: url("../../assets/arrow.png") no-repeat;
  background-size: 100%;
}

.blockchain-address {
  height: 108px;
  padding: 0 60px;
  color: #fff;
  font-family: "PingFang TC";
  font-size: 20px;
  display: flex;
  align-items: center;
}

.blockchain-address .con {
  color: #fff;
  font-family: DIN;
  font-size: 20px;
  font-weight: 700;
}

.record-table-wrapper {
  overflow: auto;
  box-sizing: border-box;
  border-radius: 10px;
}

.record-table {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
}

.record-table th {
  font-size: 20px;
  font-weight: 600;
}

.record-table th,
.record-table td {
  padding: 0 30px;
  height: 100px;
  line-height: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
}

.record-table td {
  font-size: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.4);
}

.record-table td a {
  color: #fff;
}

.record-table td a:hover {
  color: #428bca;
}
@media (max-width: 1199px) {
  .empty-box {
    padding: 150px 20px;
  }

  .section .info-item {
    width: 100% !important;
  }

  .section .info-item {
    height: 32px;
    font-size: 14px;
  }

  .section.trade-info-section .trade-item {
    padding: 15px 0;
    margin: 0 10px;
  }

  .section .info-item .item-label {
    width: 80px;
    flex-shrink: 0;
  }

  .pagination-container {
    height: 50px;
  }

  .result-box:after {
    width: 100%;
  }
  .section.base-info-section .info-item-list {
    padding: 10px;
  }
  .section.base-info-section .info-item-list .info-item + .info-item {
    margin-top: 0;
  }
  .section.trade-info-section .trade-item {
    padding: 10px;
  }
  .section.trade-info-section .trade-item .info-item {
    margin-top: 0;
  }
  /deep/ .el-tag {
    font-size: 12px;
    padding-right: 0px;
    text-align: left;
  }
  /deep/ .el-tag:after {
    content: "";
    width: 6px;
    height: 6px;
    right: 15px;
  }
  .transation-comp {
    height: auto;
    padding: 20px 10px;
    font-size: 14px;
  }
  .transation-comp .info-item {
    width: 45% !important;
  }

  .transation-comp .right-arrow {
    margin: 0 10px;
    width: 12px;
    height: 12px;
  }
  .blockchain-address {
    height: auto;
    padding: 20px 10px;
    font-size: 14px;
  }
  .blockchain-address .item-label {
    flex-shrink: 0;
  }
  .blockchain-address .con {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .record-table-wrapper {
    border-radius: 5px;
  }
  .record-table th {
    font-size: 14px;
  }
  .record-table th,
  .record-table td {
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
  }
  .record-table td {
    font-size: 12px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    margin: 0 2px;
  }
  /deep/.el-pagination .el-pagination__jump {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue